import { JSX, useEffect } from "react";
import { Popup } from "@hatch-digital-nl/abs-storybook/legacy";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { setFormFields } from "../../utils/setFormFields";
import { calculateExpiresAt } from "../../utils/calculateExpiresAt";
import {
    resetFormValues,
    setError,
    setIsAtQualification,
    setIsCreateCertificateModalOpen,
    setIsEstablishmentCertificate,
} from "../../CreateCertificateModalSlice";
import { EstablishmentCertificateForm } from "../../components/Forms/EstablishmentCertificateForm";

export const EstablishmentCertificateModal = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { selectedQualification, selectedEmployee, formValues, error } =
        useAppSelector((state) => state.createCertificateModal);

    useEffect(() => {
        setFormFields({
            selectedEmployee,
            selectedQualification,
            dispatch,
        });
    }, [selectedQualification, selectedEmployee, dispatch]);

    useEffect(() => {
        calculateExpiresAt({
            formValues,
            dispatch,
        });
    }, [
        formValues?.validAt,
        formValues?.qualification?.validityPeriod,
        formValues?.qualification?.validityType,
        formValues?.qualification?.fixedValidUntil,
        formValues?.expiresAt,
        formValues,
        dispatch,
    ]);

    return (
        <Popup
            className={"c-create-certificate-modal"}
            title={"Vestigingscertificaat toevoegen"}
            onCloseClick={() => {
                dispatch(setError(null));
                dispatch(resetFormValues());
                dispatch(setIsCreateCertificateModalOpen(false));
                dispatch(setIsEstablishmentCertificate(false));
                dispatch(setIsAtQualification(false));
            }}
        >
            {error && <div className={"c-error"}>{error}</div>}
            <EstablishmentCertificateForm />
        </Popup>
    );
};
